import { useQuery } from "@tanstack/react-query";
import { apiClient } from "./client";

export interface MissedAddressResponse {
    addressPointId: string;
    street: string;
    number: string | null;
    primarySkipReason: string;
    evaluationCount: number;
    lastCrossProduct: number | null;
    addressLat: number | null;
    addressLon: number | null;
}

export interface MissedAddressStreetGroup {
    street: string;
    includedCount: number;
    missedCount: number;
    missedAddresses: MissedAddressResponse[];
}

export interface MissedAddressSummaryResponse {
    date: string;
    totalIncluded: number;
    totalMissed: number;
    streets: MissedAddressStreetGroup[];
}

const getMissedAddresses = async (date: string): Promise<MissedAddressSummaryResponse> => {
    const response = await apiClient.get<MissedAddressSummaryResponse>("/gps/missed-addresses", {
        params: { date }
    });
    return response.data;
};

export const useMissedAddresses = (date: string, enabled: boolean = true) => {
    return useQuery<MissedAddressSummaryResponse, Error>({
        queryKey: ["gps", "missed-addresses", date],
        queryFn: () => getMissedAddresses(date),
        enabled,
        staleTime: 30 * 1000,
    });
};
